module.exports = __webpack_public_path__ + "static/media/Slide4.6d9c85f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/home/Slide4.png
// module id = 573
// module chunks = 4